import { getLocation } from '@web-platform/shared-universal-redux/src/state';
import { GLOBAL } from 'saddlebag-browser';

import type { State } from '@web-platform/shared-universal-types/src/redux/banana/state/state-banana-types';

export type TrackingReferrer = {
  readonly referrer: string;
  readonly virtualReferrer: string;
  readonly href: string;
  readonly reconciledReferrer: string;
};

export const getReferrerForTracking = (state: State): TrackingReferrer => {
  const { referrer } = GLOBAL.getDocument();
  const { href } = GLOBAL.getWindow().location;
  const { virtualReferrer } = getLocation(state);

  const reconciledReferrer = virtualReferrer || referrer;

  return {
    href,
    referrer,
    virtualReferrer,
    reconciledReferrer,
  };
};
